export const GET_RULES = 'GET_RULES';
export const SET_RULES = 'SET_RULES';
